import {
  ToggleGroup,
  ToggleGroupItem,
} from "components/DesignSystem/ToggleGroup/ToggleGroup";
import { useState } from "react";
import { ArchivedGroupCrm } from "./ArchivedGroupCrm";
import { ArchivedUserCrm } from "./ArchivedUserCrm";

export const ArchivedCrm = () => {
  const [showDataFor, setShowDataFor] = useState("Group");

  return (
    <div className="t-flex t-flex-col t-h-full t-overflow-hidden">
      <span className="t-mb-3.5 t-flex t-rounded t-w-max t-shrink-0">
        <ToggleGroup
          defaultValue="Group"
          onValueChange={(value) => setShowDataFor(value)}
        >
          <ToggleGroupItem value="Group" aria-label="Center aligned">
            Group
          </ToggleGroupItem>
          <ToggleGroupItem value="Profile" aria-label="Center aligned">
            Profile
          </ToggleGroupItem>
        </ToggleGroup>
      </span>
      <div className="t-flex-1 t-min-h-0">
        {showDataFor === "Profile" ? <ArchivedUserCrm /> : <ArchivedGroupCrm />}
      </div>
    </div>
  );
};
